import {Directive, Host, OnInit, Optional, Self} from '@angular/core';
import {_countGroupLabelsBeforeOption, _getOptionScrollPosition} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';

// After update Angular to v17(material to v16) - this directive is not needed for mat-select(Need to check)
// TODO Delete this directive and update a code where we use it previously

/**
 * Mat-select doesn't support height customizing for Option.
 * Scroll on keyboard navigation is hardcoded for constant values of option height.
 * This directive helps to override _scrollOptionIntoView method to fix calculations.
 * https://github.com/angular/components/issues/7477
 */

// $mat-select-panel-max-height - $panel-indent
const SELECT_PANEL_MAX_HEIGHT = 215;

@Directive({
  selector: '[matSelectAccessor]',
})
export class MatSelectAccessorDirective implements OnInit {
  constructor(@Host() @Self() @Optional() public _refSelect: MatSelect) {}

  public ngOnInit() {
    if (!this._refSelect) {
      return;
    }
    this._refSelect['_scrollOptionIntoView'] = this._scrollOptionIntoView.bind(this);
  }

  private _scrollOptionIntoView(index: number): void {
    const labelCount = _countGroupLabelsBeforeOption(index, this._refSelect.options, this._refSelect.optionGroups);
    // Get option height in case of option custom styles
    const optionRect = this._refSelect.options.first._getHostElement().getBoundingClientRect();
    const itemHeight = optionRect.height;
    if (index === 0 && labelCount === 1) {
      this._refSelect.panel.nativeElement.scrollTop = 0;
    } else {
      this._refSelect.panel.nativeElement.scrollTop = _getOptionScrollPosition(
        (index + labelCount) * itemHeight,
        itemHeight,
        this._refSelect.panel.nativeElement.scrollTop,
        SELECT_PANEL_MAX_HEIGHT,
      );
    }
  }
}
